@if (authEnabled()) {
  <button
    type="button"
    class="form-login-banner mobi-ui-card-major is-clickable mobi-ui-flow-x-sm text-left"
    (click)="onClick()"
  >
    <!-- Cropped 53x43 illustration; plain img avoids the shared 3:2 frame distorting it -->
    <img
      src="/illustrations/mobiliar_id_login.svg"
      alt=""
      aria-hidden="true"
      width="53"
      height="43"
      class="block shrink-0"
    />
    @if (!isAuthenticated()) {
      <span class="mobi-ui-flex-1">
        <span class="block mobi-ui-font-bold">
          {{
            'form_login_title_default'
              | texts
                : { context: 'frontend', default: 'Anmelden und automatisch ausfüllen' }
          }}
        </span>
        <span class="block">
          {{
            'form_login_subtitle_default'
              | texts
                : {
                    context: 'frontend',
                    default: 'Übernehmen Sie die Angaben einfach von Ihrer Mobiliar ID.',
                  }
          }}
        </span>
      </span>
    } @else if (filled()) {
      <span class="mobi-ui-flex-1">
        <span class="block mobi-ui-font-bold">
          {{
            'form_login_title_refill'
              | texts: { context: 'frontend', default: 'Automatisch erneut ausfüllen' }
          }}
        </span>
        <span class="block">
          {{
            'form_login_subtitle_refill'
              | texts
                : {
                    context: 'frontend',
                    default:
                      'Sie sind angemeldet. Übernehmen Sie die Angaben von Ihrer Mobiliar ID.',
                  }
          }}
        </span>
      </span>
    } @else {
      <span class="mobi-ui-flex-1">
        <span class="block mobi-ui-font-bold">
          {{
            'form_login_title_signedin'
              | texts: { context: 'frontend', default: 'Automatisch ausfüllen' }
          }}
        </span>
        <span class="block">
          {{
            'form_login_subtitle_signedin'
              | texts
                : {
                    context: 'frontend',
                    default:
                      'Sie sind angemeldet. Übernehmen Sie die Angaben von Ihrer Mobiliar ID.',
                  }
          }}
        </span>
      </span>
    }
  </button>
}
